import { Directive, HostListener, Input, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs'


@Directive({ selector: '[bindCheckboxToSubject]' })
export class BindCheckboxToSubjectDirective {
    @Input('bindCheckboxToSubject') bindCheckboxToSubject:Subject<boolean>;
    
    @HostListener('change', ['$event']) onChange(event) {
        this.bindCheckboxToSubject.next(event.target.checked);
    }

    subscription:Subscription;
    constructor(private el: ElementRef) {}

    ngOnInit() {
        this.subscription = this.bindCheckboxToSubject.subscribe((value) => {
            var element = <HTMLInputElement> this.el.nativeElement;
            element.checked = value;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }


}


// WEBPACK FOOTER //
// ./web/static/services/directives/BindCheckboxToSubject.ts